import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import {
  CheckGeneratedData,
  DataGenerate,
  GenerateDataType,
  UpsertGeneratedData,
} from "interfaces/models/generateData";
import { axiosECS } from "services/baseAxios";

const path = PATH_API.GENERATED_DATA;

/**
 * @param urn : bim file id with version with encodeURIComponent format
 * @param projectId : uuid of project
 * @returns
 */
export const checkGeneratedData = async (
  args: CheckGeneratedData
): Promise<{ dataGenerate: DataGenerate; isGenerated: boolean }> => {
  const response = await axiosECS.get(path, {
    params: args,
  });
  const dataGenerate = response?.data as DataGenerate;

  const isGenerated =
    dataGenerate?.generatedCategoryInfo &&
    dataGenerate?.generatedFamilyInstanceProperty &&
    dataGenerate?.generatedFamilyInstancePosition &&
    dataGenerate?.generatedSpace &&
    !dataGenerate?.missingViews?.length;

  return {
    dataGenerate: response.data,
    isGenerated,
  };
};

/**
 * @param urn : bim file id with version with encodeURIComponent format
 * @param dataType : type of data generated
 * @param level : type of data generated, required when data type is SPACE_LEVEL or FAMILY_INSTANCE_LEVEL
 * @returns presigned url
 */
export const getGeneratedDataByType = async (args: {
  urn: string;
  dataType: GenerateDataType;
  level?: string;
  shouldCache?: boolean;
}): Promise<ApiResponse<string>> => {
  return await axiosECS.get(`${path}/data-type`, {
    params: args,
    headers: { isIgnoreShowMessageError: true },
  });
};

/**
 * @param urn : bim file id with version with encodeURIComponent format
 * @param dataType : type of generated data
 * @returns
 */
export const upsertGeneratedData = async (
  body: UpsertGeneratedData
): Promise<ApiResponse> => {
  return await axiosECS.put(path, body);
};

/**
 * @param urn : bim file id with version with encodeURIComponent format
 * @returns
 */
export const deleteGeneratedData = async (
  urn: string
): Promise<ApiResponse> => {
  return await axiosECS.delete(path, { data: { urn } });
};
